<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

// toggle modals
const contactModalButton = document.getElementById('contact-modal-button');
const contactModalExit = document.getElementById('contact-modal-container__exit');

// toggle enquire modal
const productSection = document.querySelector('.product-details');
const enquireModalElements = document.querySelectorAll('.js-enquire-modal');

if (productSection) {
    contactModalButton.addEventListener('click', function(event) {
        for (const enquireModalElement of enquireModalElements) {
            enquireModalElement.classList.add('active-modal');
        }
    });
    
    contactModalExit.addEventListener('click', function(event) {
        for (const enquireModalElement of enquireModalElements) {
            enquireModalElement.classList.remove('active-modal');
        }
    });
}